(() => {
  function init(root) {
    if (root.dataset.exReady) return;
    root.dataset.exReady = 'true';
    const form = root.querySelector('[data-product-form]');
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = window.matchMedia('(max-width: 700px)');
    function arrangePurchase() {
      const quickBuy = root.querySelector('[data-tb-pack-quick-buy], [data-condor-quick-buy]');
      const actions = form.querySelector('.buy-actions');
      const add = form.querySelector('[data-add]');
      const delivery = root.querySelector('[data-condor-delivery]');
      const trust = root.querySelector('.trust');
      if (quickBuy && actions && add) {
        if (mobile.matches && quickBuy.parentElement !== actions) actions.insertBefore(quickBuy, add);
        if (!mobile.matches && form.nextElementSibling !== quickBuy) form.insertAdjacentElement('afterend', quickBuy);
      }
      if (mobile.matches && delivery && trust && delivery.nextElementSibling !== trust) trust.insertAdjacentElement('beforebegin', delivery);
      return Boolean(quickBuy && delivery?.dataset.ready === 'true');
    }
    if (!arrangePurchase()) {
      const observer = new MutationObserver(() => {
        if (arrangePurchase()) observer.disconnect();
      });
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ready'] });
    }
    mobile.addEventListener('change', arrangePurchase);
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-ex-image]');
      if (thumb) {
        const image = root.querySelector('.product-main');
        image.removeAttribute('srcset');
        image.src = thumb.dataset.exImage;
        image.alt = thumb.dataset.exAlt;
        root.querySelector('[data-ex-zoom]').href = thumb.dataset.exLarge;
        root.querySelectorAll('[data-ex-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        image.getAnimations().forEach(animation => animation.cancel());
        if (!reduced()) image.animate([{ transform: 'translateY(4px) scale(.99)' }, { transform: 'translateY(0) scale(1)' }], { duration: 220, easing: 'ease-out' });
      }
      if (event.target.closest('[data-ex-buy]')) {
        const target = root.querySelector('[data-condor-buy-now]') || form.querySelector('[data-add]');
        target.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        target.focus({ preventScroll: true });
      }
      if (event.target.closest('[data-ex-add]')) {
        const target = form.querySelector('[data-add]');
        if (!target.disabled) target.click();
      }
      if (event.target.closest('[data-ex-scroll]')) root.querySelector('#tb-ex-historia').scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
    });
  }
  document.querySelectorAll('[data-ex-funnel]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ex-funnel]').forEach(init));
})();
